import React from 'react';

function GradientPanel(props: object & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="550"
      height="790"
      viewBox="0 0 550 790"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as React.SVGProps<SVGSVGElement>)}
    >
      <g clipPath="url(#clip0_9235_76863)">
        <rect width="550" height="790" fill="#FAFAFA" />
        <g opacity="0.5" filter="url(#filter0_f_9235_76863)">
          <path
            d="M390.692 539.39C390.692 619.808 333.878 685 263.795 685C193.711 685 136.897 619.808 136.897 539.39C136.897 458.972 193.711 393.78 263.795 393.78C333.878 393.78 390.692 458.972 390.692 539.39Z"
            fill="#FF52D4"
          />
          <path
            d="M263.795 411.61C263.795 492.028 206.981 557.22 136.897 557.22C66.8139 557.22 10 492.028 10 411.61C10 331.192 66.8139 266 136.897 266C206.981 266 263.795 331.192 263.795 411.61Z"
            fill="#0072F5"
          />
          <path
            d="M517.59 471.043C517.59 551.461 460.776 616.652 390.692 616.652C320.609 616.652 263.795 551.461 263.795 471.043C263.795 390.624 320.609 325.433 390.692 325.433C460.776 325.433 517.59 390.624 517.59 471.043Z"
            fill="#EBF5FF"
          />
          <path
            d="M616 503.73C616 584.149 559.186 649.34 489.103 649.34C419.019 649.34 362.205 584.149 362.205 503.73C362.205 423.312 419.019 358.121 489.103 358.121C559.186 358.121 616 423.312 616 503.73Z"
            fill="#F5B8CC"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_9235_76863"
          x="-290"
          y="-34"
          width="1206"
          height="1019"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_9235_76863"
          />
        </filter>
        <clipPath id="clip0_9235_76863">
          <rect width="550" height="790" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GradientPanel;
